<template>
    <InertiaLink
        :href="href"
        :class="classes"
        class="focus:outline-none transition duration-500 ease-in-out relative block text-gray-600 hover:text-gray-900 font-bold"
    >
        <slot />
    </InertiaLink>
</template>

<script>
    export default {
        props: ['href', 'active'],

        computed: {
            classes() {
                return this.active ? 'active my-auto flex items-center p-2 text-sm' : 'my-auto flex items-center p-2 text-sm'
            }
        }
    }
</script>
<style lang="postcss" scoped>
.navbar-links a:after {
    height: 3px;
    content: '';

    @apply bg-red-700 left-0 right-0 bottom-0 w-0 absolute transition-all duration-500;
}

.navbar-links a:hover:after,
.navbar-links a.active:after {
    @apply w-full
}


</style>
